import { MDSIconKind } from "@/mds";
import { PlatformIconKind } from "@/domains/api/types";
// import downloadLaptopMobileImage from "@/assets/images/download-laptop-mobile.svg";
// import chatImage from "@/assets/images/chat-bubbles.png";
import thinkingHeadsIllustrationLight from "@/assets/images/thinking-heads-illustration-light.svg";
import thinkingHeadsIllustrationDark from "@/assets/images/thinking-heads-illustration-dark.svg";
import { ThemeType, useTheme } from "@/mds";

type PlatformIconData =
  | { icon: MDSIconKind; image?: undefined }
  | { image: string; icon?: undefined };

const lightIconKindMapping: Record<PlatformIconKind, PlatformIconData | null> = {
  [PlatformIconKind.Mem]: { icon: MDSIconKind.Logo },
  /** @deprecated */
  [PlatformIconKind.DownloadLaptopMobile]: null,
  /** @deprecated */
  [PlatformIconKind.Laptop]: null,
  /** @deprecated */
  [PlatformIconKind.Mobile]: null,
  /** @deprecated */
  [PlatformIconKind.Chat]: null,
  /** @deprecated */
  [PlatformIconKind.Chrome]: null,
  [PlatformIconKind.ArrowRight]: { icon: MDSIconKind.RightArrow },
  [PlatformIconKind.ThinkingHeads]: { image: thinkingHeadsIllustrationLight },
};

const darkIconKindMapping: Record<PlatformIconKind, PlatformIconData | null> = {
  [PlatformIconKind.Mem]: { icon: MDSIconKind.Logo },
  /** @deprecated */
  [PlatformIconKind.DownloadLaptopMobile]: null,
  /** @deprecated */
  [PlatformIconKind.Laptop]: null,
  /** @deprecated */
  [PlatformIconKind.Mobile]: null,
  /** @deprecated */
  [PlatformIconKind.Chat]: null,
  /** @deprecated */
  [PlatformIconKind.Chrome]: null,
  [PlatformIconKind.ArrowRight]: { icon: MDSIconKind.RightArrow },
  [PlatformIconKind.ThinkingHeads]: { image: thinkingHeadsIllustrationDark },
};

export const useResolvePlatformIconData = ({
  iconKind,
}: {
  iconKind: PlatformIconKind | null;
}): PlatformIconData | null => {
  const { themeType } = useTheme();

  if (!iconKind) {
    return null;
  }

  const iconKindMapping =
    themeType === ThemeType.Harvest ? darkIconKindMapping : lightIconKindMapping;

  return iconKindMapping[iconKind] ?? null;
};
